<main-content-holder>
  <h2 class="center-align" i18n="Password Reset|Password Reset title@@password-reset-title">Reset Your Password</h2>

  <div fxLayout="row" fxLayout.lt-md="column" class="full-width">
    <form [formGroup]="resetForm" class="center-align">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign In|Email input label@@sign-in-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign In|Email input placeholder@@sign-in-email-placeholder"
                  autocomplete="email"
                  type="email"
                  [minLength]="5" [maxLength]="128"></form-input>

      <app-button *ngIf="!inProgress"
                  label="Reset Password"
                  i18n-label="Password Reset|Confirm button label@@password-reset-button-label"
                  class="cta-btn center"
                  width="205px"
                  [disabled]="shouldDisableSubmit()"
                  (clicked)="resetPass()"></app-button>

      <span *ngIf="inProgress" class="progress-spinner">
        <mat-spinner color="primary" class="center" [diameter]="40"></mat-spinner>
      </span>

      <div class="footer center-align">
        <ng-container i18n="Password Reset|Back to Sign In prompt@@password-reset-back-to-sign-in-prompt">Back to
        </ng-container>
        <app-link [routerLink]="signInUrl"
                  label="Sign In"
                  i18n-label="Password Reset|Back to Sign In link label@@password-reset-back-to-sign-in-link-label"
                  class="link"></app-link>
      </div>
    </form>

    <div class="language-switch">
      <language-switch theme="dark"></language-switch>
    </div>
  </div>
</main-content-holder>
